<template>
	<div>
		This is a test!
		<toggle
			v-model="toggleState"
			message="test aria message"
			:name="'test_name'"
			:id="'test_id'"
			:showMessage="false"
		/>
	</div>
</template>

<script>
	// import "bootstrap5-toggle";
	import SapphireToggle from "COMMONS/SapphireToggle/SapphireToggle.vue";

	export default {
		data() {
			return {
				toggleState: false
			};
		},
		components: {
			"toggle": SapphireToggle
		}
		// You may need methods to handle state changes here
	};
</script>

<style scoped>
</style>
